/* unplugin-vue-components disabled */import { render } from "./item-sequencing.vue?vue&type=template&id=2c98d584"
import script from "./item-sequencing.vue?vue&type=script&lang=js"
export * from "./item-sequencing.vue?vue&type=script&lang=js"

import "./item-sequencing.vue?vue&type=style&index=0&id=2c98d584&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__